<template>
  <div class="dropdown hover-style z-index-10-fg user-menu">
    <div
      @click="
        $router.push({ name: 'user-profile' });
        $emit('closeDropdown');
      ">
      <img src="../assets/user-profile-icon.svg" />
      <span>My Profile</span>
    </div>
    <div
      @click="
        logoutUser();
        $emit('closeDropdown');
      ">
      <img src="../assets/logout.svg" />
      <span>Logout</span>
    </div>
  </div>
</template>

<script>
import { logoutUser } from '@/composables/useAuthMutate';

export default {
  name: 'UserMenu',
  setup() {
    return { logoutUser };
  },
};
</script>

<style lang="scss" scoped>
.user-menu {
  top: 100%;
  right: 0;
}
</style>
